export default __webpack_public_path__ + "static/media/05.1cf38213.jpg";